






























import { GroupLevelAttributeOption } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class AdministrationFeeItem extends Vue {
  @Prop() administrationFeeGLAV!: GroupLevelAttributeOption[];
  @Prop({ default: false }) isDraft!: boolean;
  @Prop() paymentStatus!: string;

  // Shorthand reference for rendering only
  currency = this.administrationFeeGLAV[0].value;
  // Removes trailing zeroes
  amount = (this.administrationFeeGLAV[1].value as string).split('.')[0];
  name = this.administrationFeeGLAV[2].value;
  email = this.administrationFeeGLAV[3].value;
  phone = this.administrationFeeGLAV[4].value;
}
